import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../api/axiosInstance';

// Fetch technician list thunk

// Fetch all states thunk
export const getAllStates = createAsyncThunk(
  'technicians/getAllStates',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/api/states');
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch states');
    }
  }
);

// Fetch all cities thunk
export const getAllCities = createAsyncThunk(
  'technicians/getAllCities',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/api/cities');
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch cities');
    }
  }
);
export const fetchTechnicians = createAsyncThunk(
  'technicians/fetchTechnicians',
  async ({ role = 'TECHNICIAN', page = 1, size = 10, searchBy = '', sortBy = '', order = 'ASC' } = {}, { rejectWithValue }) => {
    try {
      let url = `/api/users?role=${role}&page=${page}&limit=${size}`;
      if (searchBy) {
        url += `&searchBy=${encodeURIComponent(searchBy)}`;
      }
      if (sortBy) {
        url += `&sortBy=${encodeURIComponent(sortBy)}`;
      }
      if (order) {
        url += `&order=${order}`;
      }
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch technicians');
    }
  }
);

// Fetch pincode details thunk
export const getPincodeDetails = createAsyncThunk(
  'technicians/getPincodeDetails',
  async (pincode, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/pincodes/details/${pincode}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Failed to fetch pincode details');
    }
  }
);

// Update technician thunk
export const updateTechnician = createAsyncThunk(
  'technicians/updateTechnician',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/api/users/${id}`, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to update technician');
    }
  }
);

export const addTechnician = createAsyncThunk('technicians/addTechnician', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('/api/users', data);
    
      return response.data;
     
  } catch (error) {
    
    return rejectWithValue(error.response?.data?.message || 'Registration failed');
  }
});

// Delete technician thunk
export const deleteTechnician = createAsyncThunk(
  'technicians/deleteTechnician',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/api/users/${id}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Failed to delete technician');
    }
  }
);

const technicianSlice = createSlice({
  name: 'technicians',
  initialState: {
    list: [],
    loading: false,
    error: null,
    totalResults: 0,
    totalPages: 1,
    states: [],
    cities: [],
    statesLoading: false,
    citiesLoading: false,
    statesError: null,
    citiesError: null,
    pincodeDetails: null,
    pincodeDetailsLoading: false,
    pincodeDetailsError: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTechnicians.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTechnicians.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(action.payload)) {
          state.list = action.payload;
          state.totalResults = action.payload.length;
          state.totalPages = 1;
        } else {
          const data = action.payload.data || {};
          state.list = data.users || [];
          state.totalResults = data.total || 0;
          state.totalPages = data.pageSize ? Math.ceil((data.total || 0) / data.pageSize) : 1;
        }
      })
      .addCase(fetchTechnicians.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // States
      .addCase(getAllStates.pending, state => {
        state.statesLoading = true;
        state.statesError = null;
      })
      .addCase(getAllStates.fulfilled, (state, action) => {
        state.statesLoading = false;
        state.states = action.payload || [];
      })
      .addCase(getAllStates.rejected, (state, action) => {
        state.statesLoading = false;
        state.statesError = action.payload;
      })
      // Cities
      .addCase(getAllCities.pending, state => {
        state.citiesLoading = true;
        state.citiesError = null;
      })
      .addCase(getAllCities.fulfilled, (state, action) => {
        state.citiesLoading = false;
        state.cities = action.payload || [];
      })
      .addCase(getAllCities.rejected, (state, action) => {
        state.citiesLoading = false;
        state.citiesError = action.payload;
      })
      // Pincode details
      .addCase(getPincodeDetails.pending, state => {
        state.pincodeDetailsLoading = true;
        state.pincodeDetailsError = null;
      })
      .addCase(getPincodeDetails.fulfilled, (state, action) => {
        state.pincodeDetailsLoading = false;
        state.pincodeDetails = action.payload || null;
      })
      .addCase(getPincodeDetails.rejected, (state, action) => {
        state.pincodeDetailsLoading = false;
        state.pincodeDetailsError = action.payload;
      });
  },
});

export default technicianSlice.reducer;
